import type { ICalculatedValue } from '@ben/orion/calculated-value';
import CalculatedValue from '@ben/orion/calculated-value';
import type { IEmployeeBenefit } from '../../../types/modular-benefit';
import { useCalculatedValue } from '@ben/shared/hooks/use-calculated-value';
import { memo, useEffect } from 'react';

interface ICalculatedValueComponent extends ICalculatedValue {
  id: string;
  benefit: IEmployeeBenefit;
  benefitForm: unknown;
  validOnCurrentStep: boolean;
  dontTriggerMutation: boolean;
  setDontTriggerMutation: (value: boolean) => void;
  setBenefitForm: (
    updater: (previous: Record<string, unknown>) => Record<string, unknown>
  ) => void;
  benefitId?: number;
  enrollmentId?: string;
}

const CalculatedValueComponent = ({
  id,
  title,
  description,
  values,
  benefit,
  validOnCurrentStep,
  benefitForm,
  dontTriggerMutation,
  setDontTriggerMutation,
  setBenefitForm,
  benefitId,
  enrollmentId,
}: ICalculatedValueComponent) => {
  const { triggerMutation, isPending } = useCalculatedValue({
    benefitId,
    enrollmentId,
    benefitForm,
    setBenefitForm,
    setDontTriggerMutation,
    delay: 300,
  });

  useEffect(() => {
    if (
      !validOnCurrentStep ||
      (benefit && benefit?.benefit?.missingRequirements?.length !== 0) ||
      dontTriggerMutation
    ) {
      if (dontTriggerMutation) {
        setDontTriggerMutation(false);
      }
      return;
    }

    triggerMutation(id);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [benefitForm, validOnCurrentStep, benefit?.benefit?.missingRequirements]);

  return (
    <CalculatedValue
      title={title}
      description={description}
      isLoading={isPending}
      values={values}
    />
  );
};

export default memo(CalculatedValueComponent);
